"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseActivationStatus = void 0;
var LicenseActivationStatus;
(function (LicenseActivationStatus) {
    LicenseActivationStatus["UNUSED"] = "Unused";
    LicenseActivationStatus["ACTIVE"] = "Active";
    LicenseActivationStatus["ADDITIONAL"] = "Additional";
})(LicenseActivationStatus || (exports.LicenseActivationStatus = LicenseActivationStatus = {}));
